module.exports = __webpack_public_path__ + "static/media/power.98291636.png";